import {
  createBankTransferAccount,
  verifyBankTransfer,
  type BankTransferAccount,
} from "../../redux/payment/index";

export type WalletFundingDetails = BankTransferAccount;

export async function requestWalletFundingDetails(
  email: string,
  amountNgn: number,
  metadata?: Record<string, unknown>,
): Promise<WalletFundingDetails> {
  return createBankTransferAccount({ amount: amountNgn, email, mode: "paystack", metadata });
}

export { verifyBankTransfer };
